import styled from '@emotion/styled'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import DevelopOnSegmentImage from './DevelopOnSegmentImages'

const copy = {
  overline: `Develop on Segment without the sweat`,
  heading: `Serverless and effortless`,
  description: `Not only is Functions serverless, but it’s super easy to use with a crisp and clean code editor, testing with sample events, and reusable code from prebuilt templates and existing Functions, all in the same interface. Enhance team collaboration and experimentation with version control.`,
}

export const DevelopOnSegment = () => {
  return (
    <Wrapper>
      <SectionComponent variant="2Col" copyVariant="narrow" reverse={true}>
        <Section.Copy alignSelf="center">
          <CopyTextBase>
            <CopyText.Overline>{copy.overline}</CopyText.Overline>
            <CopyText.Heading tag="h2">{copy.heading}</CopyText.Heading>
            <CopyText.Description tag="h2">{copy.description}</CopyText.Description>
          </CopyTextBase>
        </Section.Copy>
        <Section.Contents>
          <DevelopOnSegmentImage />
        </Section.Contents>
      </SectionComponent>
    </Wrapper>
  )
}

const SectionComponent = styled(SectionBase)`
  overflow-x: visible;
  justify-content: center;
  ${Section.Wrapper} {
    padding-top: 80px;
    ${({ theme }) => theme.breakpoints.down(`md`)} {
      padding-top: 40px;
      padding-bottom: 40px;
    }
  }
`

const Wrapper = styled.div``

export default DevelopOnSegment
